import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";
import { useCalls } from "../contexts/CallsContext";

function SimpleMakeCall() {
  const { number } = useParams();
  const { handleMakeCall } = useCalls();
  const { hasFeature, waitForIpecsReady } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasFeature("click_to_dial")) {
      if (number) {
        // prefix with + for non UK numbers
        const numberToDial =
          number.length >= 10 &&
          number.substring(0, 1) !== "0" &&
          number.substring(0, 1) !== "+"
            ? "+" + number
            : number;

        // handleMakeCall fires immediately (so the "calling" UI shows right
        // away, as before) and awaits readiness itself before it actually
        // dials, instead of us waiting here before calling it at all.
        handleMakeCall(numberToDial, "audio", waitForIpecsReady());
      }
    } else {
      toast("You don't have access to the Click to Dial feature", {
        type: "error",
        toastId: "ctd-error",
      });
      navigate("/");
    }
  }, [number]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export default SimpleMakeCall;
